import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';

import { Loader2 } from 'lucide-react';
import qs from 'qs';
import { Button, FormGroup, Label, Input, cn } from 'twyne-new.ui';
import { isEmail } from 'validator';

import HeaderContainerGrid from '@/components/headerContainer/Grid';
import { ReportBody, ReportEmpty } from '@/components/reports/body'
import app from '@Stores/app';
import history from 'utils/history';

import inquiryStore from '../../stores/inquiry'

import OptoutModal from './components/OptoutModal'
import InquiryResult from './components/Results';

function Result({ data, emailInvalid, email }) {
  if (emailInvalid && email) {
    return <div className='twy-text-danger font-semi invalid-email'>Please enter a valid email</div>
  }

  if (data?.length === 0) {
    return <ReportEmpty><div className='font-semibold mt-4'>No results to show.</div></ReportEmpty>
  }

  if (!email || [null, undefined].includes(data)) {
    return null
  }

  return <InquiryResult data={data} />
}

function Search({ onSearch, email, onChangeEmail, emailInvalid }) {
  useEffect(() => {
    async function getEntities() {
      await app.listSites()
      await inquiryStore.allocation.fetchData(true)
      await inquiryStore.publisher.fetchData(true)
      await inquiryStore.page.fetchData(true)
      await inquiryStore.path.fetchData(true)
      await inquiryStore.pathUserProfile.fetchData(true)
      await inquiryStore.integration.fetchData(true)
    }
    getEntities()
  }, [])

  useEffect(() => {
    if (history.location.search.includes('email')) {
      const { location } = history
      let { email, ...search } = qs.parse(location.search, { ignoreQueryPrefix: true });
      search = qs.stringify(search);
      history.replace({
        ...location,
        search,
      });
      if (email) {
        onChangeEmail(email)
      }
    }
  })

  return <>
    <div className="flex justify-between">
      <div className="w-1/2">
        <FormGroup>
          <Label>Email</Label>
          <div className="flex gap-4">
            <Input value={email}
              className={cn(emailInvalid && 'is-invalid', 'rounded-r-none')}
              type="email"
              placeholder="Enter email"
              onInput={e => onChangeEmail(e.target.value)}
            />
            <Button
              color='accent'
              className="rounded-l-none"
              onClick={() => onSearch(email)}
              disabled={inquiryStore.isLoading || emailInvalid || !email}
            >
              {inquiryStore.isLoading ? <Loader2 size='14' className='animate-spin' /> : 'Search'}
            </Button>
          </div>
        </FormGroup>
      </div>
      <OptoutModal
        disabled={!isEmail(email)}
        email={email}
        onDeleteConsumer={emails => inquiryStore.deleteConsumerData({ emails })}
        onSuppresConsumer={emails => inquiryStore.supressConsumerData({ emails })}
      />
    </div>
  </>
}

export default function CCPALayout() {
  const [results, setResults] = useState(null)
  const [email, setEmail] = useState('')
  const [emailInvalid, setEmailInvalid] = useState(false)

  const handleChangeEmail = email => {
    setEmail(email)
    setEmailInvalid(!email || !isEmail(email))
    setResults(null)
  }

  const handleSearch = () => {
    inquiryStore.getInquiry({ email }).then(setResults)
    setResults(null)
  }

  return <>
    <HeaderContainerGrid title='Inquiry Report' />
    <ReportBody contentClassName='p-4' loading={inquiryStore.isLoading}>
      <Helmet title="Inquiry" />
      <Search
        onSearch={handleSearch}
        email={email}
        onChangeEmail={handleChangeEmail}
        emailInvalid={emailInvalid}
      />
      <Result
        data={results}
        emailInvalid={emailInvalid}
        email={email}
      />
    </ReportBody>
  </>
}
